import _extends from "/data/wwwroot/dongliyuanlin.com/web/node_modules/babel-runtime/helpers/extends";
import _regeneratorRuntime from "/data/wwwroot/dongliyuanlin.com/web/node_modules/babel-runtime/regenerator";
import _asyncToGenerator from "/data/wwwroot/dongliyuanlin.com/web/node_modules/babel-runtime/helpers/asyncToGenerator";
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//

import { mapState } from "vuex";
import CommonContent from "~/components/CommonContent";
import PageTitle from "~/components/PageTitle";
import CommonFooter from "~/components/CommonFooter";
import axios from "axios";
export default {
  name: "ProjectList",
  components: {
    CommonFooter: CommonFooter,
    CommonContent: CommonContent,
    PageTitle: PageTitle
  },
  asyncData: function () {
    var _ref2 = _asyncToGenerator( /*#__PURE__*/_regeneratorRuntime.mark(function _callee(_ref) {
      var store = _ref.store,
          query = _ref.query;
      var result;
      return _regeneratorRuntime.wrap(function _callee$(_context) {
        while (1) {
          switch (_context.prev = _context.next) {
            case 0:
              console.log(query);
              _context.next = 3;
              return store.dispatch("getPageData", { id: "9", lang: query.lang });

            case 3:
              result = _context.sent;
              return _context.abrupt("return", { pageData: result });

            case 5:
            case "end":
              return _context.stop();
          }
        }
      }, _callee, this);
    }));

    function asyncData(_x) {
      return _ref2.apply(this, arguments);
    }

    return asyncData;
  }(),
  data: function data() {
    return {

      position: "0px",
      i: 0
    };
  },

  computed: _extends({}, mapState(["winHeight", 'lang']), {
    up: function up() {
      return {
        height: this.winHeight - 60 + "px"
      };
    },
    pros: function pros() {
      if (this.lang === 'en') {
        return 'Project';
      } else {
        return '项目';
      }
    },
    marginTop: function marginTop() {
      return {
        marginTop: this.position
      };
    },
    descPageData: function descPageData() {
      var _this = this;

      return this.pageData.map(function (val, key) {
        return _this.pageData[_this.pageData.length - 1 - key];
      });
    }
  }),
  filters: {
    sub: function sub(val) {
      return val.substr(0, 10);
    }
  },
  created: function created() {},
  mounted: function mounted() {
    // document.addEventListener('mousewheel', this.mousewheel, false)
  }
};


//////////////////
// WEBPACK FOOTER
// ./node_modules/babel-loader/lib?{"babelrc":false,"cacheDirectory":true,"presets":[["/data/wwwroot/dongliyuanlin.com/web/node_modules/babel-preset-vue-app/dist/index.common.js",{"targets":{"ie":9,"uglify":true}}]]}!./node_modules/vue-loader/lib/selector.js?type=script&index=0!./pages/project/index.vue
// module id = ./node_modules/babel-loader/lib/index.js?{"babelrc":false,"cacheDirectory":true,"presets":[["/data/wwwroot/dongliyuanlin.com/web/node_modules/babel-preset-vue-app/dist/index.common.js",{"targets":{"ie":9,"uglify":true}}]]}!./node_modules/vue-loader/lib/selector.js?type=script&index=0!./pages/project/index.vue
// module chunks = 9